import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styles from './IconButtonWrapper.scss';

const IconButtonWrapper = forwardRef(({ icon, description = '', onClick, className, size, ...rest }, ref) => {
  return (
    <button
      {...rest}
      className={[styles['icon-button-wrapper'], size ? styles[size] : '', className || ''].join(' ')}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.code === 'Enter') {
          e.preventDefault();
          onClick();
        }
      }}
      ref={ref}
      tabIndex={0}
      aria-label={description}
      type="button">
      <img src={icon} alt={`Icon ${description}`} />
    </button>
  );
});

export default IconButtonWrapper;
IconButtonWrapper.prototypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  description: PropTypes.string,
};
